import React, { useEffect, useRef } from 'react';
import CountrySelectionModal from '../CountrySelectionModal/CountrySelectionModal';
import CountrySelectionDropdown from './CountrySelectionDropdown';
import { useCountrySelectorVariant } from './useCountrySelectorVariant';
import type { CountrySelectorProps } from './countrySelectionTypes';

/**
 * Picks the presentation of the country / dial-code picker: the bottom sheet on mobile viewports
 * (and on layouts without a desktop dropdown), the anchored dropdown on desktop.
 * Dropdown-only props (closeOnOutsideClick, outsideClickIgnoreRefs, listboxId) are ignored by the sheet.
 */
const CountrySelector: React.FC<CountrySelectorProps> = (props) => {
  const { isOpen, onClose } = props;
  const variant = useCountrySelectorVariant();
  const previousVariantRef = useRef(variant);

  useEffect(() => {
    if (previousVariantRef.current !== variant && isOpen) onClose();
    previousVariantRef.current = variant;
  }, [variant, isOpen, onClose]);

  if (variant === 'sheet') return <CountrySelectionModal {...props} />;
  return <CountrySelectionDropdown {...props} />;
};

export default CountrySelector;
